import { call, put, takeLatest } from 'redux-saga/effects';

import { getTypes as getTypesApi } from '../../services';
import { displayNotification, checkOnline, getNotification } from '../notifications';
import { REQUEST_TYPES, receiveTypes } from './actions';

export function* doRequestTypes({ query }) {
  try {
    const { values: types } = yield call(getTypesApi, query);
    yield put(receiveTypes(types));
  } catch (error) {
    yield console.error(error);
    yield call(checkOnline);
    yield put(displayNotification(getNotification('getTypes', 'error')()));
  }
}

export const sagas = [takeLatest(REQUEST_TYPES, doRequestTypes)];
